<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <drop-down
            style="margin-right: 40px"
            class="nav-item "
            :title="$t('settings.title')"
            title-classes="nav-link"
            icon="ti-settings"
            @close="closeLanguageDropdown"
          >
            <!-- Diğer Ayarlar -->
            <a  class="dropdown-item" href="#" @click="openChangePasswordModal">
              <i class="ti-lock"></i> {{ $t('settings.changePass') }}
            </a>

            <!-- Dil Değiştirme Bağlantısı -->
            <a
              class="dropdown-item"
              href="#"
              @click.stop.prevent="toggleLanguageDropdown"
            >
              <i class="ti-world"></i> {{ $t('settings.changeLang') }}
            </a>

            <!-- Dil Alt Menüsü -->
            <div v-if="showLanguageDropdown" class="dropdown-submenu">
              <a class="dropdown-item" href="#" @click.prevent="setLocale('en')">English</a>
              <a class="dropdown-item" href="#" @click.prevent="setLocale('tr')">Türkçe</a>
              <a class="dropdown-item" href="#" @click.prevent="setLocale('de')">Deutsch</a>
            </div>
          </drop-down>
        </ul>
      </div>
    </div>

    <!-- Parola Değiştirme Modalı -->
    <div v-if="showPasswordModal" class="modal" tabindex="-1" role="dialog" style="display: block;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="ti-lock"></i> {{ $t('settings.changePass') }}</h5>
            <button type="button" class="close" @click="closeChangePasswordModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="changePassword">
              <div class="form-group">
                <label for="oldPassword">{{ $t('settings.oldPass') }}</label>
                <input type="password" id="oldPassword" v-model="oldPassword" class="form-control" required />
              </div>
              <div class="form-group">
                <label for="newPassword">{{ $t('settings.newPass') }}</label>
                <input type="password" id="newPassword" v-model="newPassword" class="form-control" required />
              </div>
              <div class="form-group">
                <label for="confirmPassword">{{ $t('settings.confirmPass') }}</label>
                <input type="password" id="confirmPassword" v-model="confirmPassword" class="form-control" required />
              </div>
              <button type="submit" class="btn btn-primary">{{ $t('settings.changePass') }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import config from "@/routing_map.json";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

export default {
  data() {
    return {
      showLanguageDropdown: false,
      showPasswordModal: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      if(name)return this.capitalizeFirstLetter(name);

    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.showLanguageDropdown = false; // Ana menü kapandığında dil dropdownunu kapat
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      this.showLanguageDropdown = false; // Dil seçildikten sonra alt menüyü kapat
    },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    // Ana dropdown kapandığında dil dropdown'unu kapat
    closeLanguageDropdown() {
      this.showLanguageDropdown = false;
    },
    // Parola Değiştirme Modali Açma
    openChangePasswordModal() {
      this.showPasswordModal = true;
    },
    // Parola Değiştirme Modali Kapatma
    closeChangePasswordModal() {
      this.showPasswordModal = false;
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    },
    // Parola Değiştirme İşlemi
      changePassword() {
        // Yeni parola ve doğrulama parolası eşleşmiyor
        if (this.newPassword !== this.confirmPassword) {
          this.notifyVue('top', 'right', this.$t('settings.passwordsDoNotMatch'), "warning")

          return;
        }

        // Sunucuya gönderilecek veriler
        const passwordData = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        };

        // Token, headers'a eklenmeli
        axios.defaults.headers.common.authorization = localStorage.getItem('authorization')

        // Axios ile sunucuya istek gönder
        axios.post(
          `${config.app_url}/login/update-password`,
          passwordData )
          .then(response => {
            if (response.data.success) {
              this.notifyVue('top', 'right', this.$t('settings.passwordChanged'), "success")
              this.showPasswordModal = false;
              // Parola güncellendikten sonra input alanlarını temizle
              this.oldPassword = '';
              this.newPassword = '';
              this.confirmPassword = '';
            } else {

              this.notifyVue('top', 'right', this.$t('settings.incorrectInf'), "warning")
            }
          })
          .catch(error => {
            this.notifyVue('top', 'right', this.$t('settings.errorOccurred'), "warning")

          });
      },

      notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000
      });
    }

  },
};
</script>

<style>
/* Modal Basit Stil */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-dialog {
  max-width: 500px;
  width: 100%;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
}

/* Dil Alt Menüsünü Stilize Etmek için */
.dropdown-submenu {
  padding-right: 20px; /* Alt menüyü biraz içeriye kaydır */
}
</style>
